export default function EquipesPage() {
    return (
        <div className="py-10">
            <h1 className="text-4xl font-black uppercase text-white">Équipes</h1>
        </div>
    );
}